export default __webpack_public_path__ + "static/media/outgoing-green.a66e95a2.svg";